import {getComplianceScorePercentage} from '@domain/rcfa'
import {Typography} from '@mui/material'

export const RcfaComplianceScore = ({
  value = 0,
  maxValue,
  dataTestId,
  isMobile
}: {
  value?: number
  maxValue: number
  dataTestId: string
  isMobile: boolean
}) => {
  const showPercentage = maxValue > 0

  return (
    <Typography
      variant={isMobile ? 'subtitle2' : 'body1'}
      fontWeight={600}
      data-test-id={dataTestId}
    >
      {value}/
      <Typography component="span" fontSize="inherit" color="text.secondary">
        {maxValue}
      </Typography>
      {showPercentage && ` (${getComplianceScorePercentage(value, maxValue)}%)`}
    </Typography>
  )
}
